import { ClimaticPeril } from "src/app/api/model/climaticPerilVm";

export type ClimaticState = {
  ClimaticPeril: ClimaticPeril[];
};

export const initialClimaticState: ClimaticState = {
  ClimaticPeril: [],
};
